import type {
  AddParticipantsBody,
  AddParticipantsParams,
  AddParticipantsResponse,
  DeleteParticipantsBody,
  DeleteParticipantsParams,
  DeleteParticipantsResponse,
  GetParticipantsParams,
  GetParticipantsResponse,
} from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const manualParticipantsApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getManualParticipants: build.query<GetParticipantsResponse, GetParticipantsParams>({
      query: ({ retailUnit, lotteryId }) =>
        `/${retailUnit}/lottery/${lotteryId}/manual-participants`,
      providesTags: ['ManualParticipants'],
    }),
    addNewManualParticipants: build.mutation<
      AddParticipantsResponse,
      AddParticipantsParams & AddParticipantsBody
    >({
      query: ({ retailUnit, lotteryId, newParticipants }) => ({
        url: `/${retailUnit}/lottery/${lotteryId}/manual-participants`,
        method: 'POST',
        body: { newParticipants },
      }),
      invalidatesTags: ['ManualParticipants'],
    }),
    deleteManualParticipant: build.mutation<
      DeleteParticipantsResponse,
      DeleteParticipantsParams & DeleteParticipantsBody
    >({
      query: ({ retailUnit, lotteryId, participant }) => ({
        url: `/${retailUnit}/lottery/${lotteryId}/manual-participants/delete`,
        method: 'POST',
        body: { participant },
      }),
      invalidatesTags: ['ManualParticipants'],
    }),
  }),
});

export const {
  useGetManualParticipantsQuery,
  useAddNewManualParticipantsMutation,
  useDeleteManualParticipantMutation,
} = manualParticipantsApis;
